export default __webpack_public_path__ + "static/media/icon-instagram.2ffa38cc.svg";